export default "__VITE_ASSET__C2S_WOoL__"